




























































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import AnalysisMixin from "@/mixins/http/AnalysisMixin";
import { MediumCoverage, MediumType } from "../../models";
import { BASE_API_URL } from "@/utils/Constants";
import jsFileDownloader from "js-file-downloader";
import { authStore, currentUserStore } from "@/store/typed";
import Throttler from "@/utils/Throttler";
import Percent from "@/filters/Percent";
import FormatNumber from "@/filters/FormatNumber";
import NumberFormatter from "@/service/NumberFormatter";
import HeatmapTable from "@/components/HeatmapTable.vue";
import VContentLoading from "@/components/VContentLoading.vue";
import MediumSelector from "@/components/Detail/MediumSelector.vue";
import { UserRoles } from "@/models/User";

@Component({
  components: { HeatmapTable, VContentLoading, MediumSelector },
  filters: { Percent, FormatNumber },
})
export default class MediaTab extends Mixins(AnalysisMixin) {
  @Prop({ required: true }) readonly isocronIds!: string[];
  @Prop({ required: true }) readonly population!: number;
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly areaIds!: string[];

  private mediumTypeId: string | null = null;
  private reach = "national";
  private throttler: Throttler = new Throttler();

  private loading = false;
  private readonly exportDataUrl = `${BASE_API_URL}current_user/scouting/export.xlsx`;

  private unfilteredAudiences: MediumCoverage[] = [];

  @Watch("isocronIds")
  onIsocronIdsChanged() {
    this.throttler.run(() => {
      this.load();
    });
  }

  @Watch("areaIds")
  onAreaIdsChanged() {
    this.throttler.run(() => {
      this.load();
    });
  }

  @Watch("population")
  onPopulationChanged(value: number) {
    this.throttler.run(() => {
      this.load();
    });
  }

  mounted() {
    this.load();
  }

  get columns() {
    return [
      { name: "name", label: "Canale" },
      { name: "audience", label: "Audience" },
      { name: "coverage", label: "Cop." },
      { name: "dispersion", label: "Disp." },
      { name: "budget", label: "Budget", tooltip: "" },
    ];
  }

  get audiences() {
    let rows = this.unfilteredAudiences.filter(
      (audience) => audience.mediumTypeId === this.mediumTypeId
    );
    rows.forEach((audience) => (audience.tooltip = audience.budgetDescription));
    return rows;
  }

  get reaches() {
    return MediumType.reaches;
  }

  async onDownloadClicked() {
    await new jsFileDownloader({
      url: this.exportDataUrl,
      timeout: 240 * 1000,
      headers: [
        { name: "Authorization", value: `Bearer ${authStore.accessToken}` },
      ],
      filename: `ricerca_del_${this.$moment().format("DD-MM-YYYY")}.xlsx`,
    });
  }

  onMediumTypologyAndReachSelected(mediumTypeId: string, reach?: string) {
    this.mediumTypeId = mediumTypeId;
    this.reach = reach || "national";
  }

  formatCurrency(value: string) {
    return NumberFormatter.format(parseInt(value)) + " €";
  }

  get payload() {
    return { isocron_ids: this.isocronIds, area_ids: this.areaIds };
  }

  async load() {
    this.unfilteredAudiences = [];
    this.loading = true;
    const uncoveredAudiences: MediumCoverage[] = await this.getMediumCoverages(
      this.payload
    );
    this.unfilteredAudiences = uncoveredAudiences.map((audience) => {
      audience.coverage = audience.audience / this.population;
      return audience;
    });
    this.loading = false;
  }

  get canExportMedia() {
    return currentUserStore.user?.isOneOf([
      UserRoles.ANALYST,
      UserRoles.ADMINISTRATOR,
      UserRoles.SUPERADMIN,
      UserRoles.SYSTEM_ADMIN,
    ]);
  }
}
